export default __webpack_public_path__ + "static/media/IMG_7146.343d84ed.JPG";